module.exports = __webpack_public_path__ + "img/KatSL.0d3cea79.svg";